// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchResults_root__U1-9w"};